<template>
	<order-block
			v-for="orderBlock in orderBlocks"
			:order-block="orderBlock"
			:key="orderBlock.id"
	/>
</template>

<script setup lang="ts">
	import {useStore} from '@/store';
	import OrderBlock from '@/components/orderblock/OrderBlock.vue';
	import {storeToRefs} from 'pinia';

	const store = useStore();

	const {orderBlocks} = storeToRefs(store);

</script>
